import MuiPage from "./MuiPage";

export { default as ResponsivePageIcon } from "./PageHeader/ResponsiveIcon";
export { default as Backdrop } from "./Backdrop";
export default MuiPage;
